import { useTranslation } from 'react-i18next';

const usePasswordValidation = (password: string): { isValid: boolean; text: string }[] => {
  const { t } = useTranslation();

  const isHasLength = password.length >= 7;
  const isContainsNumber = /\d/.test(password);
  const isHasSpecialChar = /[^A-Za-z0-9]/.test(password);

  return [
    {
      isValid: isHasLength,
      text: t('rules.password_length'),
    },
    {
      isValid: isContainsNumber,
      text: t('rules.password_number'),
    },
    {
      isValid: isHasSpecialChar,
      text: t('rules.password_spec_char'),
    },
  ];
};

export default usePasswordValidation;
